import { termTranslationsUpload } from "./TermTranslationsUpload.slice";

export const termTranslationsUploadActions = { ...termTranslationsUpload.actions };
